export function normalizeUrl(url: string | null): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  const normalized = trimmed.endsWith("/") ? trimmed.slice(0, -1) : trimmed;
  if (!normalized.startsWith("http://") && !normalized.startsWith("https://")) {
    return `https://${normalized}`;
  }
  return normalized;
}
